import React from 'react';
import { Link } from 'react-router-dom'
import Btn from './Btn';
import './Navbtns.css'
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';


const Navbtns = () => {

    const { t } = useTranslation();

    const changeLanguage = () => {
        const newLang = i18n.language === 'en' ? 'ar' : 'en';
        i18n.changeLanguage(newLang);
        document.body.dir = newLang === 'ar' ? 'rtl' : 'ltr';
    };

    return ( 
        <div className='Navbtns'>
            <Link to={''} className='Navbtn'>
                {t('nav.features')}
            </Link>
            <Link to={''} className='Navbtn'>
                {t('nav.events')}
            </Link>
            <Link to={''} className='Navbtn'>
                {t('nav.create')}
            </Link>
            <Link to={''} className='Navbtn'>
                {t('nav.booking')}
            </Link>
            <Link to={''} className='Navbtn'>
                {t('nav.blog')}
            </Link>
            <Btn BtnText={t('nav.contact')} BtnStyle='WhiteBtn'/>

            <button className='LangBtn' onClick={changeLanguage}>
                Change Language
            </button>
        </div>
     );
}
 
export default Navbtns;